import {
  Component, EventEmitter, Inject, Injector,
  Input,
  OnInit, Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { Unidad } from '../../../_models/unidad';
import { EstudioService } from '../estudio.service';
import { HttpClient } from '@angular/common/http';
import { GLMLanguageService } from '../../../_services/glm-language.service';
import { MapaCurricularService } from '../mapa-curricular/_services/mapa-curricular.service';
import { GlmModalService } from '../../../_components/glm-modal/glm-modal.service';
import { CustomAlertService } from '../../../_components/custom-alert/custom-alert.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UnidadEtapasService } from '../unidad-etapas/_services/unidad-etapas.service';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS } from '../../../_models/moment-formats';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { map } from 'rxjs/operators';


@Component({
  selector: 'unidad-form-dialog',
  standalone: false,
  templateUrl: './unidad-form-dialog.component.html',
  styleUrls: ['unidad-etapas-home.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    {provide: MAT_DATE_LOCALE, useValue: 'es-mx'},

    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},

  ]
})


export class UnidadFormDialogComponent implements OnInit {

  unidadForm: UntypedFormGroup;

  _unidad: Unidad;

  @Input()
  unidad: Unidad;
  @Input()
  materias: any;
  @Input()
  profesores: any;

  @Output()
  isDirty = new EventEmitter();
  @Output()
  formLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  materiasPeriodoOpts: any = [];
  profesoresOpts: any = [];
  alumnosIEPOpts = [];
  periodos: any = [];

  guardando = false;
  unidadReady = false;
  isModal = false;

  fechaIniciaMinMax: any;
  fechaFinMinMax: any;
  fechaPubMinMax: any;

  textoBusquedaCursos: string;
  textoBusquedaAreas: string;

  onSave = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<UnidadFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private injector: Injector,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private estudioService: EstudioService,
    private unidadEtapasService: UnidadEtapasService,
    private mapaCurricularService: MapaCurricularService,
    private modalService: GlmModalService,
    private languageService: GLMLanguageService,
    private customAlertService: CustomAlertService,
    private _adapter: DateAdapter<any>) {
  }

  ngOnInit() {
    // this._adapter.setLocale('es-CO')
    this.unidad = new Unidad({ id: 0 });
    this._unidad = new Unidad({ id: 0 });
    if (this.data != null) {
      this._unidad = this.data.unidad; // this.injector.get('unidad', null);
      this.materiasPeriodoOpts = this.data.materiasPeriodo; // this.injector.get('materiasPeriodo', []);
      this.profesoresOpts = this.data.profesores; // this.injector.get('profesores', []);
      this.periodos = this.data.periodos;
      this.textoBusquedaCursos = this.data.textoBusquedaCursos;
      this.textoBusquedaAreas = this.data.textoBusquedaAreas;
    }

    if (this._unidad.periodo.hasOwnProperty('fechaInicia')) {
      this.fechaIniciaMinMax = {
        min: this._unidad.periodo.fechaInicia.substring(0, 10),
        max: this._unidad.periodo.fechaFin.substring(0, 10)
      };
      this.fechaFinMinMax = {
        min: this._unidad.periodo.fechaInicia.substring(0, 10),
        max: this._unidad.periodo.fechaFin.substring(0, 10)
      };
      this.fechaPubMinMax = {
        min: this._unidad.periodo.fechaInicia.substring(0, 10),
        max: this._unidad.periodo.fechaFin.substring(0, 10)
      };
    } else {
      this.fechaIniciaMinMax = {
        min: this.periodos[0].fechaInicia.substring(0, 10),
        max: this.periodos[0].fechaFin.substring(0, 10)
      };
      this.fechaFinMinMax = {
        min: this.periodos[0].fechaInicia.substring(0, 10),
        max: this.periodos[0].fechaFin.substring(0, 10)
      };
      this.fechaPubMinMax = {
        min: this.periodos[0].fechaInicia.substring(0, 10),
        max: this.periodos[0].fechaFin.substring(0, 10)
      };
    }


    if (this._unidad == null) {
      this.materiasPeriodoOpts = this.materias;
      this.profesoresOpts = this.profesores;
      this.estudioService.getUnidad(this.unidad.id).subscribe(res => {
        this._unidad = this.estudioService.extractData(res);
        this.fechaIniciaMinMax = {
          min: this._unidad.periodo.fechaInicia.substring(0, 10),
          max: this._unidad.periodo.fechaFin.substring(0, 10)
        };
        this.fechaFinMinMax = {
          min: this._unidad.periodo.fechaInicia.substring(0, 10),
          max: this._unidad.periodo.fechaFin.substring(0, 10)
        };
        this.fechaPubMinMax = {
          min: this._unidad.periodo.fechaInicia.substring(0, 10),
          max: this._unidad.periodo.fechaFin.substring(0, 10)
        };
        this.buildForm();
      }, err => {

      });
    } else {
      this.isModal = true;
      this.buildForm();
    }
  }

  buildForm() {
    const currNombre = this._unidad.nombre,
      currResumen = this._unidad.resumen,
      currFechaInicia = this._unidad.fechaInicia,
      currFechaPublicar = this._unidad.fechaPublicar,
      currFechaFin = this._unidad.fechaFin,
      currMateriasPeriodo = this._unidad.materias && this._unidad.materias.length > 0 ?
        this._unidad.materias.map(materia => {
          return materia.id;
        }) : [],
      currEditores = this._unidad.editores && this._unidad.editores.length > 0 ?
        this._unidad.editores.map(editor => {
          return editor.id;
        }) : [],
      currAlumnosIEP = this._unidad.alumnosIEP && this._unidad.alumnosIEP.length > 0 ?
        this._unidad.alumnosIEP.map(alumno => {
          return alumno.id;
        }) : [],
      currClasesEsperadas = this._unidad.clasesEsperadas || 0,
      currEstadoActiva = this._unidad.isActive;

    this.unidadForm = this.fb.group({
      nombre: [currNombre, Validators.required],
      resumen: [currResumen],
      fechaInicia: [{ value: currFechaInicia, disabled: false }, Validators.required],
      fechaFin: [{ value: currFechaFin, disabled: currFechaInicia === '' }, Validators.required],
      fechaPublicar: [{ value: currFechaPublicar, disabled: currFechaPublicar === '' }],
      clasesEsperadas: [currClasesEsperadas],
      materiasPeriodo: [currMateriasPeriodo, Validators.required],
      editores: [currEditores],
      alumnosIEP: [currAlumnosIEP],
      isActive: [currEstadoActiva]
    });
    if (currMateriasPeriodo.length > 0) {
      this.seleccionMCP(false);
    }
    this.unidadReady = true;

    this.formLoaded.emit(true);
    // this.onChanges();
  }

  onChanges() {
    this.unidadForm.valueChanges.subscribe(val => {

      if (!this.unidadForm.pristine) {
        this.isDirty.emit(true);
      }
    });
  }

  dateChange(type: string, event: MatDatepickerInputEvent<Date>) {
    if (type === 'fechaInicio') {
      this.fechaFinMinMax.min = event.value.toJSON().substr(0, 10);
      this.fechaPubMinMax.min = event.value.toJSON().substr(0, 10);
      this.unidadForm.get('fechaFin').enable();
    }
    if (type === 'fechaFin') {
      this.fechaPubMinMax.max = event.value.toJSON().substr(0, 10);
      this.unidadForm.get('fechaPublicar').enable();
    }
  }

  seleccionMCP(isOpen) {
    if (!isOpen) {
      const idsMCP = this.unidadForm.get('materiasPeriodo').value;
      if (idsMCP.length > 0) {
        this.estudioService.getAlumnosIEP(idsMCP.toString()).pipe(map(al => {
          return al as Object;
        })).subscribe(res => {
          this.alumnosIEPOpts = res as any[];
          if (!this.unidadForm.get('alumnosIEP')) {
            this.unidadForm.addControl('alumnosIEP', new UntypedFormControl());
          }
          if (this.alumnosIEPOpts.length === 0) {
            this.unidadForm.patchValue({ alumnosIEP: null });
          }
        }, err => {
          console.error('Error en la petición.');
        });
      } else {
        this.alumnosIEPOpts = [];
        this.unidadForm.patchValue({ alumnosIEP: [] });
      }
    }
  }

  guardar(navegar: boolean) {
    const formVals = this.unidadForm.value;
    this.guardando = true;
    this._unidad.nombre = formVals.nombre;
    this._unidad.resumen = formVals.resumen && formVals.resumen.length > 0 ? formVals.resumen : '';
    this._unidad.fechaInicia = formVals.fechaInicia ? formVals.fechaInicia : '';
    this._unidad.fechaFin = formVals.fechaFin ? formVals.fechaFin : '';
    this._unidad.fechaPublicar = formVals.fechaPublicar ? formVals.fechaPublicar : '';
    this._unidad.materias = formVals.materiasPeriodo.length > 0 ?
      formVals.materiasPeriodo.map(materiaPeriodo => {
        return { id: materiaPeriodo };
      }) : [];
    this._unidad.editores = formVals.editores.length > 0 ?
      formVals.editores.map(editor => {
        return { id: editor };
      }) : [];
    this._unidad.alumnosIEP = formVals.alumnosIEP && formVals.alumnosIEP.length > 0 ?
      formVals.alumnosIEP.map(alumno => {
        if (this.alumnosIEPOpts.indexOf(alumno.id) > -1) {
          return { id: alumno };
        }
      }) : [];
    this._unidad.clasesEsperadas = formVals.clasesEsperadas;
    this._unidad.isActive = formVals.isActive;
    if (this._unidad.alumnosIEP[0] == null) {
      this._unidad.alumnosIEP = [];
    }
    if (this._unidad.id > 0) {
      this.estudioService.actualizarUnidad(this._unidad).subscribe(resp => {
        this.estudioService.actualizarElemento('unidad', resp);
        if (this.isModal) {
          this.onSave.emit(resp);
        } else {
          this.guardando = false;
          this.snackBar.open(
            `La unidad se ha guardado correctamente.`,
            null,
            { duration: 2250 });
          this.unidadEtapasService.setMaterias(this.estudioService.extractData(resp).materias);
          this.unidadForm.markAsPristine();
          this.isDirty.emit(false);
        }
      }, err => {
        this.guardando = false;
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la unidad. <br> Código de error: ${err.statusText}`
        });
      });
    } else {
      this.estudioService.crearUnidad(this._unidad).subscribe(resp => {
        const nuevaUnidad = new Unidad(resp);
        this.guardando = false;
        // this.estudioService.actualizarElemento('nueva-unidad', nuevaUnidad);
        this.onSave.emit(nuevaUnidad);
        const modelo = {
          idOrigen: nuevaUnidad.id,
          estado: true
        };
        this.estudioService.setUnidadFavorita(modelo).subscribe(res => { });
        if (navegar) {
          window.open('estudio/unidad/' + nuevaUnidad.id, '_blank');
        }
      }, err => {
        this.guardando = false;
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible crear la unidad. ${err.error} <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  cancelar() {
    this.modalService.cerrarModal();
  }
}
